import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterDashboardGenreSimplifie } from '../../types';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardGenreSimplifie>) => void;
  filter: Partial<FilterDashboardGenreSimplifie>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { valid } = filter;

  function setDisplayInvalidGenreSimplifie(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      valid: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <AntdCheckbox checked={!valid} onChange={setDisplayInvalidGenreSimplifie}>
        Afficher les genres simplifiés inactifs
      </AntdCheckbox>
    </div>
  );
}
